export function extractErrorMessage(parsed: unknown, fallback: string): string {
    if (!parsed || typeof parsed !== "object") return fallback;
    const p = parsed as Record<string, unknown>;
    return (
        (typeof p.title === "string" && p.title) ||
        (typeof p.message === "string" && p.message) ||
        (typeof p.error === "string" && p.error) ||
        (typeof p.detail === "string" && p.detail) ||
        fallback
    );
}

export async function toError(res: Response, fallback: string): Promise<Error> {
    try {
        const p = await res.json();
        return new Error(extractErrorMessage(p, fallback));
    } catch {
        return new Error(fallback);
    }
}
